// src/main.js
import './assets/theme.css';
import './style.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// Sentry
import * as Sentry from '@sentry/vue';

// Your API client (axios instance with /api prefix + auth interceptor)
import api from '@/api';

// Base UI components
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseInput from '@/components/ui/BaseInput.vue';
import BaseSelect from '@/components/ui/BaseSelect.vue';
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue';

// (Dev convenience) cashflow store handle for quick console inspection
import { useCashflowSimStore } from '@/modules/cashflow-simulator/store.js';
import { useAuthStore } from '@/stores/auth';

const app = createApp(App);

// Create Pinia as a named instance so we can expose it for debugging
const pinia = createPinia();
app.use(pinia);

// Router
app.use(router);

const auth = useAuthStore();
auth.hydrate(); // fire and forget

// Initialize Sentry before mount
Sentry.init({
  app,
  dsn: 'https://f7769b74efbeef79de152d2ba31e0eff@o4509128937308160.ingest.us.sentry.io/4509128940388352'
});

// Register global UI components
app.component('BaseButton', BaseButton);
app.component('BaseInput', BaseInput);
app.component('BaseSelect', BaseSelect);
app.component('BaseCheckbox', BaseCheckbox);

// Make your API client available as this.$api in all components
app.config.globalProperties.$api = api;

// Dev-only globals for easy debugging from the browser console
if (process.env.NODE_ENV !== 'production') {
  window.__APP__ = app;
  window.__PINIA__ = pinia;
  window.router = router;

  // Handy: a ready-to-use cashflow store instance
  try {
    window.__CF__ = useCashflowSimStore(pinia);
    // Now in DevTools you can do: __CF__.status, __CF__.runId, __CF__.doLaunch({...}), etc.
  } catch (e) {
    // ignore if module path changes
  }
}

// Mount
app.mount('#app');
